'use strict';

const fDisappear = () => {
    const aElements = document.querySelectorAll('.js-disappear');

    function fRemoveElement(oElement) {
        oElement.style.transition = '.4s';
        oElement.style.opacity = 0;

        setTimeout(function () {
            oElement.remove();
        }, 300);
    }

    for (let i = 0; i < aElements.length; i += 1) {
        let iTime = aElements[i].getAttribute('data-disappear');

        if (iTime) {
            

            setTimeout(function() {
                fRemoveElement(aElements[i]);
            }, (iTime * 1000));
        }
    }
}